angular.module('rightPaneModule')
  .controller('DistrictGradesController', [
    '$scope',
    '$state',
    'edxReportItemService',
    'gradeApi',
    'navigation',
    'reportErrors',
    'tableColumns',
    'tableSort',
    'timeframe',
    function(
      $scope,
      $state,
      edxReportItemService,
      $gradeApi,
      navigation,
      $reportErrors,
      tableColumns,
      tableSort,
      timeframe) {

    $scope.years = { list: null, selected: {} };

    $scope.listTableColumns = tableColumns.getColumns('grade');

    $scope.timeframes = {
      list: [
        { id: '7d', name: 'Last 7 Days', by: 'day', active: false },
        { id: '30d', name: 'Last 30 Days', by: 'week', active: true }
      ],
      selected: {}
    };

    var sortGrades = function (grades) {
        if ($state.params.sort === 'name') {
            // We need "PreK" before "Grade 1"
            $scope.listTableData = tableSort.sortByColumn(grades, 'id');
        } else {
            $scope.listTableData = tableSort.sortColumn($scope.listTableColumns, grades);
        }
    };

    var updateGrades = function() {
        $scope.gradesReportingUrl = $gradeApi.getGradesReportingExportUrl();
        $scope.gradesError = null;

        $scope.listTableData = undefined;
        $gradeApi.getGradesReporting().then(function(grades) { // success
            sortGrades(grades);
        }, function(error) { // got an error
            $scope.listTableData = undefined;
            $scope.gradesError = $reportErrors.getErrorMessage(error);
        });
    };

    var updateTableSort = function () {
        if ($scope.listTableData) {
            sortGrades($scope.listTableData);
        }
    };

    var initializeData = function(item) {
      $scope.item = item;
    };

    var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
      initializeData(item);
    });

    $scope.$on('updateSortableTable', updateTableSort);
    $scope.$on('yearSelected', updateGrades);
    $scope.$on('timeframeSelected', updateGrades);
    $scope.$on('timeframeInitialized', updateGrades);
    $scope.$on('listTableRowClicked', function (e, item) {
        navigation.goToItem(item);
    });

    var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
      $scope.years.list = angular.copy(years);
    });

    $scope.$on('$destroy', function () {
      itemSubscription.dispose();
      timeframeSubscription.dispose();
    });
  }]);
